import { render, staticRenderFns } from "./appNotificationManage.vue?vue&type=template&id=0c2b68da&scoped=true"
import script from "./appNotificationManage.vue?vue&type=script&lang=js"
export * from "./appNotificationManage.vue?vue&type=script&lang=js"
import style0 from "./appNotificationManage.vue?vue&type=style&index=0&id=0c2b68da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b68da",
  null
  
)

export default component.exports